import { api } from './api.js';
import { TAG_CONTACT_MISC, TAG_FILE_MISC, TAG_MEETING_MISC, TAG_ORGANIZATION_MISC, TAG_PROJECT_MISC } from './tags.js';
import { convertToUrlSearchParams } from '../utils/helper.js';

export const miscEndpoints = api.injectEndpoints({
    endpoints: (builder) => ({
        getCountries: builder.query({
            query: () => ({
                url: '/misc/countries',
                method: 'GET'
            })
        }),
        getSocialMediaTypes: builder.query({
            query: () => ({
                url: '/misc/social-media-types',
                method: 'GET'
            })
        }),
        getContactCountries: builder.query({
            query: () => ({
                url: '/misc/contact-countries',
                method: 'GET'
            }),
            providesTags: [TAG_CONTACT_MISC]
        }),
        getMeetingCountries: builder.query({
            query: () => ({
                url: '/misc/meeting-countries',
                method: 'GET'
            }),
            providesTags: [TAG_MEETING_MISC]
        }),
        getOrganizationCountries: builder.query({
            query: () => ({
                url: '/misc/organization-countries',
                method: 'GET'
            }),
            providesTags: [TAG_ORGANIZATION_MISC]
        }),
        getProjectCountries: builder.query({
            query: () => ({
                url: '/misc/project-countries',
                method: 'GET'
            }),
            providesTags: [TAG_PROJECT_MISC]
        }),
        getFileCountries: builder.query({
            query: () => ({
                url: '/misc/file-countries',
                method: 'GET'
            }),
            providesTags: [TAG_FILE_MISC]
        }),
        getContactCompanies: builder.query({
            query: () => ({
                url: '/misc/contact-companies',
                method: 'GET'
            }),
            providesTags: [TAG_CONTACT_MISC]
        }),
        getContactJobTitles: builder.query({
            query: () => ({
                url: '/misc/contact-job-titles',
                method: 'GET'
            }),
            providesTags: [TAG_CONTACT_MISC]
        }),
        getCalendarMeetingLocations: builder.query({
            query: () => ({
                url: '/misc/meeting-locations',
                method: 'GET'
            })
        }),
        getPoliticalAffiliations: builder.query({
            query: () => ({
                url: '/misc/political-affiliations-types',
                method: 'GET'
            })
        }),
        getParticipantRoleTypes: builder.query({
            query: () => ({
                url: '/misc/participant-role-types',
                method: 'GET'
            })
        }),
        getPrivateUsers: builder.query({
            query: ({ permission, params }) => ({
                url: `/misc/private-users/${permission}?${convertToUrlSearchParams(params)}`,
                method: 'GET'
            })
        }),
        getSkills: builder.query({
            query: () => ({
                url: `/misc/skills`,
                method: 'GET'
            })
        }),
        getEconomicRegions: builder.query({
            query: () => ({
                url: `/misc/economic-regions`,
                method: 'GET'
            })
        }),
        getAssociatedOrganizationsTypes: builder.query({
            query: () => ({
                url: `/misc/associated-organizations-types`,
                method: 'GET'
            })
        })
    })
});

export const {
    useGetCountriesQuery,
    useGetSocialMediaTypesQuery,
    useGetContactCountriesQuery,
    useGetMeetingCountriesQuery,
    useGetOrganizationCountriesQuery,
    useGetProjectCountriesQuery,
    useGetFileCountriesQuery,
    useGetContactCompaniesQuery,
    useGetContactJobTitlesQuery,
    useGetCalendarMeetingLocationsQuery,
    useGetPoliticalAffiliationsQuery,
    useGetParticipantRoleTypesQuery,
    useLazyGetPrivateUsersQuery,
    useGetSkillsQuery,
    useGetEconomicRegionsQuery,
    useGetAssociatedOrganizationsTypesQuery
} = miscEndpoints;
